export const PLAN_LABELS = {
  FREE: 'Darmowy',
  PRO_30_DAYS: 'Pro Jednorazowy',
  PRO_MONTHLY: 'Pro Miesięczny',
  PRO_YEARLY: 'Pro Roczny'
};

export const BILLING_PLANS = [
  {
    id: 'PRO_30_DAYS',
    name: PLAN_LABELS.PRO_30_DAYS,
    price: '39',
    suffix: '/ jednorazowo',
    mode: 'payment',
    description: 'Pełny dostęp przez 30 dni.'
  },
  {
    id: 'PRO_MONTHLY',
    name: PLAN_LABELS.PRO_MONTHLY,
    price: '29',
    suffix: '/ miesiąc',
    mode: 'subscription',
    description: 'Pełny dostęp rozliczany co miesiąc.'
  },
  {
    id: 'PRO_YEARLY',
    name: PLAN_LABELS.PRO_YEARLY,
    price: '299',
    suffix: '/ rok',
    mode: 'subscription',
    description: 'Pełny dostęp rozliczany co rok.'
  }
];

export const PAID_PLAN_IDS = new Set(
  BILLING_PLANS.map((plan) => plan.id)
);

export const isPaidPlan = (planId) => PAID_PLAN_IDS.has(planId);

export const getPlanLabel = (planId) => (
  PLAN_LABELS[planId] ?? PLAN_LABELS.FREE
);